export default "__VITE_ASSET__luaCK5qd__"